export const initValues = {
  congress_speciality: "",
  city: "",
  month: "",
  year: "",
};
